import React, { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import logo from "../assets/media/ImageAnekant/AP.png";

function Navbar() {
  const navigate = useNavigate();
  const username = localStorage.getItem("username");

  // Handle Logout
  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("username");
    navigate("/");
  };

  // Close navbar on link click (for mobile)
  useEffect(() => {
    const navLinks = document.querySelectorAll(".nav-link, .dropdown-item");
    const navbarCollapse = document.getElementById("navbarNav");

    navLinks.forEach((link) => {
      link.addEventListener("click", function () {
        if (this.classList.contains("dropdown-toggle")) return;
        if (navbarCollapse.classList.contains("show")) {
          new window.bootstrap.Collapse(navbarCollapse, { toggle: true });
        }
      });
    });

    return () => {
      navLinks.forEach((link) => {
        link.removeEventListener("click", () => {});
      });
    };
  }, []);

  return (
    <nav className="navbar navbar-expand-lg sticky-top custom-navbar px-3">
      <div className="container-fluid">
        {/* Logo */}
        <Link className="navbar-brand d-flex align-items-center" to="/">
          <img src={logo} alt="Company Logo" className="navbar-logo me-2" />
        </Link>

        {/* Hamburger */}
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNav"
          aria-controls="navbarNav"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <i className="fa fa-bars text-white fs-3"></i>
        </button>

        {/* Navbar Menu */}
        <div
          className="collapse navbar-collapse justify-content-end"
          id="navbarNav"
        >
          <ul className="navbar-nav align-items-lg-center">
            {/* Powerplants Dropdown */}
            <li className="nav-item dropdown">
              <Link
                className="nav-link dropdown-toggle"
                to="#"
                id="powerplantsDropdown"
                role="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                Powerplants
              </Link>
              <ul
                className="dropdown-menu"
                aria-labelledby="powerplantsDropdown"
              >
                <li>
                  <Link className="dropdown-item" to="/cogeneration">
                    Cogeneration Plant
                  </Link>
                </li>
                <li>
                  <Link className="dropdown-item" to="/powergeneration">
                    Power Generation Plant
                  </Link>
                </li>
                <li>
                  <Link className="dropdown-item" to="/renewableenergy">
                    Renewable Energy Plant
                  </Link>
                </li>
                <li>
                  <Link className="dropdown-item" to="/renewableagency">
                    Renewable Agencies
                  </Link>
                </li>
              </ul>
            </li>

            {/* Other Nav Links */}
            <li className="nav-item">
              <Link className="nav-link" to="/suppliers">
                Suppliers
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/classifieds">
                Classifieds
              </Link>
            </li>
            <li className="nav-item">
              <Link className="nav-link" to="/banners">
                Banners
              </Link>
            </li>

            {/* Admin Dropdown (Only visible if logged in) */}
            {username ? (
              <li className="nav-item dropdown ms-lg-3">
                <button
                  className="btn admin-btn dropdown-toggle"
                  id="adminDropdown"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  {username}
                </button>
                <ul
                  className="dropdown-menu dropdown-menu-end"
                  aria-labelledby="adminDropdown"
                >
                  <li>
                    <Link className="dropdown-item" to="/profile">
                      Profile
                    </Link>
                  </li>
                  <li>
                    <button
                      className="dropdown-item text-danger"
                      onClick={handleLogout}
                    >
                      Logout
                    </button>
                  </li>
                </ul>
              </li>
            ) : (
              <li className="nav-item ms-lg-3">
                <Link className="btn btn-light" to="/login">
                  Admin Login
                </Link>
              </li>
            )}
          </ul>
        </div>
      </div>
    </nav>
  );
}

export default Navbar;
